var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',[_vm._l((_vm.tiles),function(tile,id){return _c('currently-recruiting-tile',{key:id,attrs:{"id":id,"title":tile.title}})}),_c('secondary-navigation',{attrs:{"show-back":""}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }